<template>
  <div class="message-list">
    <c-table
      ref="table"
      :columns="columns"
      :url="tableUrl"
      :fetchPage="true"
      @after-fetch="afterFetch"
    >
      <div slot="operate">
        <el-button size="small" type="primary" @click="more" v-if="permissionFn('admin')">
          {{tableUrl==='/aliapi/voice'?'查看全部':'查看我的'}}
        </el-button>
        <el-upload
          class="inline-block"
          action="/api/aliapi/uploadvoice"
          :show-file-list="false"
          :on-success="handleRecordSuccess"
          :before-upload="beforeUpload"
          accept="audio/mpeg,application/zip,.rar"
        >
          <el-button size="small" type="primary">上传录音</el-button>
        </el-upload>
      </div>

      <el-table-column slot="voice" label="听录音" width="160">
        <template v-slot="{row}">
          <!-- <audio :src="`/api/aliapi/getvoice?id=${row.id}`" controls></audio> -->
          <i class="el-icon-loading voice" v-if="row.playStatus===1"></i>
          <i class="el-icon-video-pause voice" @click="pause(row)" v-else-if="row.playStatus===2"></i>
          <i class="el-icon-video-play voice" @click="play(row)" v-else></i>
          <!-- <el-slider v-model="row.percentage" :min="0" :max="100" :step="0.01" @change="changePercentage"></el-slider> -->
          <template v-if="row.duration">{{row.currentTime | timeFormat}}/{{row.duration | timeFormat}}</template>
        </template>
      </el-table-column>
      <el-table-column slot="caozuo" label="操作" width="160">
        <template v-slot="{row}">
          <!-- <el-button type="text" @click="preview(row)">查看文件</el-button> -->
          <el-link type="primary" :underline="false" :href="`/api/aliapi/getcontent?id=${row.id}`" target="_blank">查看文件</el-link>
          <el-link type="primary" :underline="false" :href="`/api/aliapi/getvoice?id=${row.id}`" download="download">下载</el-link>
        </template>
      </el-table-column>
    </c-table>
    <!-- <el-dialog
      title=""
      :visible.sync="centerDialogVisible"
      width="80%"
      center>
      <iframe src="/api/aliapi/getcontent?id" frameborder="0"></iframe>
    </el-dialog> -->
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'
import permissionMixins from '@/mixins/permission'

export default {
  name: 'staff-basic',
  mixins: [ mixin, permissionMixins ],
  components: { CTable },
  data () {
    return {
      columns: [
        { prop: 'name', label: '文件名', minWidth: '400' },
        { prop: 'time', label: '时间', width: '200' },
        { prop: 'status', label: '状态', width: '100' },
        { slot: 'voice' },
        { prop: 'who', label: '上传者', width: '100', disable: true },
        { slot: 'caozuo' }
      ],
      duration: 0,
      tableUrl: '/aliapi/voice'
    }
  },
  filters: {
    timeFormat(time) {
      const fixedTime = val => +val < 10 ? '0' + val : val
      time = parseInt(time)
      const h = Math.floor(time / 3600)
      const m = Math.floor(time % 3600 / 60)
      const s = Math.floor(time % 3600 % 60)
      const hText = h !== 0 ? fixedTime(h) + ':' : ''
      const mText = (h + m) !== 0 ? fixedTime(m) + ':' : '00:'
      const sText = (h + m + s) !== 0 ? fixedTime(s) : '00'
      return hText + mText + sText
    }
  },
  methods: {
    // percentage({ duration, currentTime }) {
    //   return duration > 0 ? +((currentTime * 100 / duration).toFixed(2)) : 0
    // },
    // changePercentage(val) {
    //   console.info(this._row.duration * val / 100)
    //   // this._row.currentTime = this._row.duration * val / 100
    //   this._audio.currentTime = this._row.duration * val / 100
    //   console.info(this._audio.currentTime)
    // },
    handleRecordSuccess(response, file, fileList) {
      this.$message.success('上传成功')
      this.$refs.table.reload()
    },
    beforeUpload(file) {
      if (!['.zip', '.rar', '.mp3'].some(x => file.name.endsWith(x))) {
        this.$message.error('录音文件格式不正确')
        return false
      }
    },
    preview({ id }) {
      this.$api.record.getcontent({
        id
      }).then(res => {

      })
    },
    afterFetch(res) {
      res.data && res.data.data.forEach(item => {
        item.playStatus = 0
        item.duration = 0
        item.currentTime = 0
      })
    },
    play(row) {
      const { id } = this._row || {}
      if (this._row && id !== row.id) {
        this._row.playStatus = 0
        this._row.currentTime = 0
      }
      this._row = row
      this._row.playStatus = 1
      if (this._audio) {
        id !== this._row.id ? (this._audio.src = '/api/aliapi/getvoice?id=' + this._row.id) : (this._row.playStatus = 2)
      } else {
        this._audio = new Audio('/api/aliapi/getvoice?id=' + row.id)
        this._audio.addEventListener('canplaythrough', () => {
          this._row.duration = this._audio.duration || 0
          this._row.playStatus = 2
        })
        this._audio.addEventListener('timeupdate', res => {
          // console.info(res.target.currentTime)
          this._row.currentTime = res.target.currentTime
          // this._row.percentage = this.percentage(this._row)
        })
      }
      this._audio.play()
    },
    pause(row) {
      this._audio.pause()
      row.playStatus = 0
    },
    more() {
      const isAll = this.tableUrl === '/aliapi/voice2'
      this.tableUrl = isAll ? '/aliapi/voice' : '/aliapi/voice2'
      this.columns.find(x => x.prop === 'who').disable = isAll
      this.$nextTick(() => {
        console.info(3)
        this.$refs.table.reload()
      })
    }
  }
}
</script>

<style lang="scss" scope>
.voice{
  font-size: 22px;
  cursor:pointer;
  margin-right:5px;
  vertical-align: middle;
}
.inline-block{
  display: inline-block;
}
</style>
